export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/create-transaction-worker-script.7caeb25d.worker.js");
}
